 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin":"admin","appointment":"appointment","auth":"auth","billing":"billing","client":"client","corporate":"corporate","diagnostics~patient":"diagnostics~patient","diagnostic~diagnostics":"diagnostic~diagnostics","diagnostics":"diagnostics","patient":"patient","diagnostic":"diagnostic","encounter":"encounter","insurance":"insurance","opd":"opd","pharmacy":"pharmacy","registeradmissions":"registeradmissions","registerclient":"registerclient","registerpatient":"registerpatient","registerresources":"registerresources","registerservice":"registerservice","registeruser":"registeruser","registerwards":"registerwards","schedule":"schedule","virtual-care":"virtual-care"}[chunkId]||chunkId) + "." + {"admin":"bd358f84","appointment":"95046654","auth":"337d79ba","billing":"140c8969","chunk-2d0b2b77":"7403150b","chunk-2d0d7292":"124f404c","chunk-d687bd58":"69d4a97d","client":"408f9a90","corporate":"526cffc1","diagnostics~patient":"f5f67f68","diagnostic~diagnostics":"0f054f9e","diagnostics":"9823c3ac","patient":"bac83397","diagnostic":"6c975ffa","encounter":"a0c3999a","insurance":"da89e764","opd":"d966dc78","pharmacy":"67c6ebbe","registeradmissions":"02924b1f","registerclient":"92e11f92","registerpatient":"5f92327c","registerresources":"a1f34410","registerservice":"7d7f90a2","registeruser":"84489d8e","registerwards":"df9347ed","schedule":"5ef6d674","virtual-care":"858a1659","chunk-1045967e":"a9b635a3","chunk-2d216214":"b4ecd604","chunk-25931486":"2c4a70c0","chunk-2d0afe2b":"e104e11c","chunk-2d0b631a":"01a56366","chunk-2d0b9817":"f1c5617a","chunk-2d0c1d65":"66c11afb","chunk-2d0cedb0":"78cbc278","chunk-2d0d3152":"8d98d57d","chunk-2d0d39ca":"bf50fba1","chunk-2d0f0499":"96b04201","chunk-2d207d15":"176fca26","chunk-2d2086a4":"4e4fbf29","chunk-2d208732":"1d37ea41","chunk-2d216821":"b69423af","chunk-2d21d8f0":"e3139108","chunk-2d222d06":"54918b35","chunk-2d2265a5":"296e82af","chunk-2d2307de":"3a170db7","chunk-3c747a6e":"85c38fad","chunk-99eabd98":"139867e8","chunk-ac42786e":"e710bf82","chunk-0c9b27ab":"826ea0ab","chunk-2d0b2b54":"a38975b3","chunk-2d0c13e2":"142b5f1a","chunk-2d0c7e55":"f4111604","chunk-2d0e4bf4":"79120a41","chunk-2d0e5bf3":"6dd88873","chunk-93a9034e":"35d0c163","chunk-2d20ed73":"f718e7ea","chunk-2d21ed07":"15438d80","chunk-2d0c93b5":"41239628","chunk-12e34259":"4120a6ce","chunk-2d0af67b":"d319ddae","chunk-2d221f94":"c496b11a","chunk-371a77d2":"5ba3a12d","chunk-2d0b5db4":"50742222","chunk-2d0f0654":"ab0dfe01","chunk-2d0b2195":"545e8c67","chunk-2d21afa5":"21b90ba0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"patient":1,"schedule":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin":"admin","appointment":"appointment","auth":"auth","billing":"billing","client":"client","corporate":"corporate","diagnostics~patient":"diagnostics~patient","diagnostic~diagnostics":"diagnostic~diagnostics","diagnostics":"diagnostics","patient":"patient","diagnostic":"diagnostic","encounter":"encounter","insurance":"insurance","opd":"opd","pharmacy":"pharmacy","registeradmissions":"registeradmissions","registerclient":"registerclient","registerpatient":"registerpatient","registerresources":"registerresources","registerservice":"registerservice","registeruser":"registeruser","registerwards":"registerwards","schedule":"schedule","virtual-care":"virtual-care"}[chunkId]||chunkId) + "." + {"admin":"31d6cfe0","appointment":"31d6cfe0","auth":"31d6cfe0","billing":"31d6cfe0","chunk-2d0b2b77":"31d6cfe0","chunk-2d0d7292":"31d6cfe0","chunk-d687bd58":"31d6cfe0","client":"31d6cfe0","corporate":"31d6cfe0","diagnostics~patient":"31d6cfe0","diagnostic~diagnostics":"31d6cfe0","diagnostics":"31d6cfe0","patient":"2f58f5bb","diagnostic":"31d6cfe0","encounter":"31d6cfe0","insurance":"31d6cfe0","opd":"31d6cfe0","pharmacy":"31d6cfe0","registeradmissions":"31d6cfe0","registerclient":"31d6cfe0","registerpatient":"31d6cfe0","registerresources":"31d6cfe0","registerservice":"31d6cfe0","registeruser":"31d6cfe0","registerwards":"31d6cfe0","schedule":"3fd10b3c","virtual-care":"31d6cfe0","chunk-1045967e":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-25931486":"31d6cfe0","chunk-2d0afe2b":"31d6cfe0","chunk-2d0b631a":"31d6cfe0","chunk-2d0b9817":"31d6cfe0","chunk-2d0c1d65":"31d6cfe0","chunk-2d0cedb0":"31d6cfe0","chunk-2d0d3152":"31d6cfe0","chunk-2d0d39ca":"31d6cfe0","chunk-2d0f0499":"31d6cfe0","chunk-2d207d15":"31d6cfe0","chunk-2d2086a4":"31d6cfe0","chunk-2d208732":"31d6cfe0","chunk-2d216821":"31d6cfe0","chunk-2d21d8f0":"31d6cfe0","chunk-2d222d06":"31d6cfe0","chunk-2d2265a5":"31d6cfe0","chunk-2d2307de":"31d6cfe0","chunk-3c747a6e":"31d6cfe0","chunk-99eabd98":"31d6cfe0","chunk-ac42786e":"31d6cfe0","chunk-0c9b27ab":"31d6cfe0","chunk-2d0b2b54":"31d6cfe0","chunk-2d0c13e2":"31d6cfe0","chunk-2d0c7e55":"31d6cfe0","chunk-2d0e4bf4":"31d6cfe0","chunk-2d0e5bf3":"31d6cfe0","chunk-93a9034e":"31d6cfe0","chunk-2d20ed73":"31d6cfe0","chunk-2d21ed07":"31d6cfe0","chunk-2d0c93b5":"31d6cfe0","chunk-12e34259":"31d6cfe0","chunk-2d0af67b":"31d6cfe0","chunk-2d221f94":"31d6cfe0","chunk-371a77d2":"31d6cfe0","chunk-2d0b5db4":"31d6cfe0","chunk-2d0f0654":"31d6cfe0","chunk-2d0b2195":"31d6cfe0","chunk-2d21afa5":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
